<div (mouseenter)="mouseEnterOnMenuSidebar()" (mouseleave)="mouseLeaveFromMenuSidebar()">
<!-- Brand Logo -->
<a [routerLink]="['/']" class="brand-link border-0">
    <ng-container *ngIf="!showMiniLogoIcon">
        <img src="../../../../assets/img/Main_Logo.svg" width="100%">
    </ng-container>
    <ng-container *ngIf="showMiniLogoIcon">
        <img src="../../../../assets/img/Main_Logo.svg" width="100%" *ngIf="onMouseOver">
        <img src="../../../../assets/img/Aero-Lounge 1 (1).png" height="45px" *ngIf="!onMouseOver">
    </ng-container>
</a>

<!-- Sidebar -->
<div class="sidebar">
    <div class="form-inline">
        <app-sidebar-search></app-sidebar-search>
    </div>

    <!-- Sidebar Menu -->
    <nav class="mt-2" >
        <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
        >
            <ng-container *ngFor="let item of menu">
                <app-menu-item  [menuItem]="item"/>
            </ng-container>
        </ul>
    </nav>
</div>
</div>
